<template>
  <a class="user-logout v2_color_white text_underline font_size_1000rem pr-2" href="#" @click="logout">Log Out</a>
</template>

<script>
import { SIGN_OUT_ACTION } from '@/store';

export default {
  name: 'userLogout',
  data() {
    return {};
  },
  methods: {
    logout: async function () {
      await this.$store.dispatch(SIGN_OUT_ACTION);
      this.$router.push('/login');
    },
  },
};
</script>
